import { render, staticRenderFns } from "./PicklDetails.vue?vue&type=template&id=4cc8d1bb&scoped=true&"
import script from "./PicklDetails.vue?vue&type=script&lang=js&"
export * from "./PicklDetails.vue?vue&type=script&lang=js&"
import style0 from "./PicklDetails.vue?vue&type=style&index=0&id=4cc8d1bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8d1bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc8d1bb')) {
      api.createRecord('4cc8d1bb', component.options)
    } else {
      api.reload('4cc8d1bb', component.options)
    }
    module.hot.accept("./PicklDetails.vue?vue&type=template&id=4cc8d1bb&scoped=true&", function () {
      api.rerender('4cc8d1bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PicklDetails.vue"
export default component.exports